export default __webpack_public_path__ + "static/fundo-historia-b2d5a4ccb3eac4b30194aaf86fee2318.jpg";